import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty, assign } from 'lodash';
import bytesToSize from 'utils/bytesToSize';
import { Image } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  
  deleteImg: {
    width: '180px',
    margin: '0 auto',
    marginBottom: '22px',
  }, 
  deleteBtn: {
    backgroundColor: '#DF3744 !important',
    color: 'white !important',
    borderRadius: '14px',
    fontWeight: '500',
    border: '0',
    marginLeft: '12px',
    padding: '10px 20px',
    fontSize: '16px',
  },
});

const FilesDropzone = props => {
  const { files, setFiles, title, secondaryTitle, dzFileIcon, customDZconfigs, showThumbs, showUploadbtn, uploadAllCallback, serverRejectedFiles } = props;

  const classes = useStyles();

  const [rejectedFiles, setRejectedFiles] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRejectedFiles([]);
    }, 15000);
    return () => clearTimeout(timer);
  }, [rejectedFiles]);
  
  useEffect(() => {
    if (!isEmpty(serverRejectedFiles)) {
      setRejectedFiles(serverRejectedFiles);
    }
  }, [serverRejectedFiles]);

  const handleDropAccepted = useCallback((acceptedFiles, event ) => {
    setRejectedFiles([]);
    setFiles(acceptedFiles);
  }, []);

  const handleDropRejected = useCallback((fileRejections, event ) => {
    setRejectedFiles(fileRejections);
  }, []);

  let genral_config = { onDropAccepted: handleDropAccepted, onDropRejected: handleDropRejected };
  let dzconfig = assign({}, genral_config, customDZconfigs);

  const handleRemoveAll = () => {
    setFiles([]);
  };

  const removeFile = async (e, index) => {
    e.preventDefault();
    let files_arr = [...files];
    files_arr.splice(index, 1);
    setFiles(files_arr);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone(dzconfig);

  const DZFileIconDefault = () => (
    <img
      alt="Select file"
      src="/images/undraw_add_file2_gvbb.svg"
    />
  );

  // const renderThumbnails = (file, index) => {
  //   if (file.type.includes('image')) {
  //     return (
  //       <div key={file.name} className='img-uploaded'>
  //         <img
  //           src={URL.createObjectURL(file)}
  //           alt={file.name}
  //           style={{ width: 37, height: 32 }}
  //         />
  //         <p>{file.name} - {bytesToSize(file.size)}</p>

  //         <button onClick={(e) => removeFile(e, index)} className='dropzone-del-icon'> <Image src='/assets/images/dropzone-del-white.svg' /> </button>
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div key={file.name}>
  //         <p>{file.name} - {bytesToSize(file.size)}</p>
  //         <button onClick={(e) => removeFile(e, index)}>Remove</button>
  //       </div>
  //     );
  //   }
  // };

  const renderThumbnails = (file, index) => {
   
    const isImage =
      file.type?.includes("image") || // Uploaded files with type
      /\.(jpe?g|png|gif|bmp|webp)$/i.test(file.name || ""); // File name check for URLs or preloaded files
 
    let imageSrc = ""; // Initialize image source
 
    // Safely determine the source of the image
    if (isImage) {
      if (file instanceof File || file instanceof Blob) {
        // Safely create an object URL for File/Blob
        imageSrc = URL.createObjectURL(file);
      } else if (file.name) {
        // Assume it's a preloaded file with a URL as the name
        imageSrc = file.name;
      }
    }
 
    // Render the image thumbnail if valid
    if (isImage && imageSrc) {
      return (
        <div key={index} className="img-uploaded">
          <img
            src={imageSrc}
            style={{ width: 34, height: 27 }}
            onLoad={() => URL.revokeObjectURL(imageSrc)}
          />
          <p>
            {file.name} - {bytesToSize(file.size)}
          </p>
          <button
            onClick={(e) => removeFile(e, index)}
            className="dropzone-del-icon"
          >
            <Image src="/assets/images/dropzone-del-white.svg" />
          </button>
        </div>
      );
    }
 
    // Render non-image files
    return (
      <div key={index} className="dropzoneAttachDiv">
        <p>
          {file.name} - {bytesToSize(file.size)}
        </p>
        <button className={classes.deleteBtn} onClick={(e) => removeFile(e, index)}>Remove</button>
      </div>
    );
  };
  
  const fileRejectionItems = rejectedFiles.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map(e => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));

  return (
    <div>
      <div {...getRootProps()} className='dropzone' >
        <input {...getInputProps()} key={files.length} />
        <Image src='/assets/images/dropzone-img.svg' className='dropzone-img'/>
      </div>

      {showThumbs && files.length > 0 && (
        <div>
          {files.map((file, index) => renderThumbnails(file, index))}
          {showUploadbtn && (
            <button className="font-13 font-weight-medium gradient-btn" onClick={uploadAllCallback}>Upload all</button>
          )}
          {files.length > 1 && (
            <button className={classes.deleteBtn} onClick={handleRemoveAll}>Remove all</button>
          )}
        </div>
      )}

      {rejectedFiles.length > 0 && (
        <div>
          <h4>Rejected files</h4>
          <ul>{fileRejectionItems}</ul>
        </div>
      )}
    </div>
  );
};

FilesDropzone.propTypes = {
  className: PropTypes.string,
  files: PropTypes.any.isRequired,
  setFiles: PropTypes.any.isRequired
};

FilesDropzone.defaultProps = {
  title: '',
  secondaryTitle: '',
  dzFileIcon: '',
  dzconfigs: {},
  showThumbs: true,
  thumbsAt: 'bottom',
  showUploadbtn: false,
  uploadAllCallback: () => { /*nothing to do*/ },
  serverRejectedFiles: []
};

export default FilesDropzone;
